import React,  { Component } from 'react';
import { Link } from 'react-router-dom';
import "./index.css";

import {Navbar} from 'react-bootstrap';

const Navigation = () => (
  <NavigationClass />
);


class NavigationClass extends Component {
	render () {
		return (
			<Navbar collapseOnSelect expand="lg" variant="dark" className="nav-glass">
				<Navbar.Brand>
					<Link className="nav-brand" to="/">Insured FYI Insurance Verification</Link>
				</Navbar.Brand>
			</Navbar>
		);
	}

}


export default Navigation;


